<template>
  <div class="main-stations__type4">
    <div class="main-stations__title">Инсоляция</div>
    <div v-if="station.insolation !== null" class="main-stations__insolation">
      <p>Горизонтальная: <span>{{ station.insolation.horiz }} W/m2</span></p>
      <p>В плоскости: <span>{{ station.insolation.plane }} W/m2</span></p>
      <p>По площади: <span>{{ areaInsolation }} kW</span></p>
      <!--                  <p>Энергии за сегодня: <span>12412141 kWh</span></p>-->
    </div>
<!--    <div v-else class="main-stations__insolation_error">-->
<!--      <span class="danger">-->
<!--      <span class="danger">-->
<!--        <i></i>Нет данных-->
<!--      </span>-->
<!--    </div>-->
    <div v-if="station.meteo !== null" class="main-stations__weather">
      <div class="temp"><img src="../../../assets/images/icon_meteo_01.svg" alt="">Температура:
        <span>{{ station.meteo.temperature }}°C</span></div>
      <div class="humidity"><img src="../../../assets/images/icon_humidity.png" alt="">Влажность:
        <span>{{ station.meteo.humidity }}%</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Insolation',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  computed: {
    areaInsolation () {
      return Math.round(this.station.insolation.area * this.station.insolation.plane / 1000)
    }
  }
}
</script>
